import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.status.pending');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-status-pending',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.status.pending/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageStatusPendingComponent implements OnInit {
    public loading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.check()) {
            this.service.href('/access');
            return;
        }
        await this.refresh();
    }

    public isActive() {
        return this.service.auth.session.account_status === 'ACTIVE';
    }

    public isEmailVerified() {
        return Boolean(this.service.auth.session.email_verified);
    }

    public statusLabel() {
        if (!this.isEmailVerified()) return '이메일 확인 대기';
        if (!this.isActive()) return '관리자 승인 대기';
        if (!(this.service.auth.session.portals || []).length) return '데이터셋 역할 배정 대기';
        return '포털 진입 가능';
    }

    public async resendVerification() {
        if (this.loading || this.isEmailVerified()) return;
        this.loading = true;
        try {
            let result: any = await this.service.request.post('/api/account/email/resend', {
                email: this.service.auth.session.email
            });
            await this.service.modal.show({
                title: result.code === 202 ? '요청 접수' : '발송 요청 실패',
                message: result.code === 202
                    ? '이메일 발송 설정이 완료된 환경이면 확인 안내를 다시 발송합니다.'
                    : (result.data && result.data.message ? result.data.message : '요청을 처리하지 못했습니다.'),
                cancel: false,
                action: '확인',
                actionBtn: result.code === 202 ? 'success' : 'error',
                status: result.code === 202 ? 'success' : 'error'
            });
        } finally {
            this.loading = false;
        }
    }

    public async refresh() {
        if (this.loading) return;
        this.loading = true;
        try {
            let result: any = await this.service.request.post('/api/account/me');
            if (result.code === 200 && result.data.next !== '/status/pending') {
                location.href = result.data.next;
                return;
            }
            if (result.code !== 200) {
                location.href = '/access';
            }
        } finally {
            this.loading = false;
        }
    }

    public async logout() {
        await this.service.request.post('/api/account/logout');
        location.href = '/access';
    }
}

export default PageStatusPendingComponent;